import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils/cn'

export type ProjectRole =
  | 'super_user'
  | 'admin'
  | 'approver'
  | 'data_entry'
  | 'viewer'

const ROLE_CONFIG: Record<ProjectRole, { label: string; className: string }> =
  {
    super_user: {
      label: 'سوپر یوزر',
      className: 'bg-purple-500/15 text-purple-400 border-purple-500/30',
    },
    admin: {
      label: 'مدیر',
      className: 'bg-primary/20 text-blue-400 border-primary/30',
    },
    approver: {
      label: 'تأییدکننده',
      className: 'bg-secondary/20 text-secondary border-secondary/30',
    },
    data_entry: {
      label: 'ورود اطلاعات',
      className: 'bg-muted text-muted-foreground border-border',
    },
    viewer: {
      label: 'مشاهده‌گر',
      className: 'bg-muted text-muted-foreground/70 border-border',
    },
  }

interface RoleChipProps {
  role: ProjectRole
  className?: string
}

export function RoleChip({ role, className }: RoleChipProps) {
  const config = ROLE_CONFIG[role]
  return (
    <Badge
      variant="outline"
      className={cn('text-xs font-medium', config.className, className)}
    >
      {config.label}
    </Badge>
  )
}
